import {createEvent} from "effector";

export const changeTestingFiltersEv = createEvent()

export const filterAfterApiCallEv = createEvent()
